import ReactCountryFlag from "react-country-flag";

type CompanyNameWithFlagProps = {
  name: string;
  country?: string;
  countryCode?: string;
  nameClassName?: string;
  onNameClick?: () => void;
  countryClassName?: string;
};

const CompanyNameWithFlag = ({ name, country, countryCode, nameClassName = "tw-text-sm tw-text-gray-max", onNameClick, countryClassName = "" }: CompanyNameWithFlagProps) => (
  <div className="tw-min-w-0">
    {onNameClick ? (
      <button type="button" onClick={onNameClick} className={`tw-block tw-w-full tw-truncate tw-border-none tw-bg-transparent tw-p-0 tw-text-left !tw-capitalize hover:tw-underline ${nameClassName}`}>
        {name}
      </button>
    ) : (
      <div className={`tw-truncate ${nameClassName}`}>{name}</div>
    )}
    {country && (
      <div className={`tw-mt-1 tw-flex tw-items-center tw-gap-1 tw-text-xs tw-text-gray-900 ${countryClassName}`}>
        {countryCode && <ReactCountryFlag svg countryCode={countryCode} />}
        <span className="tw-truncate">{country}</span>
      </div>
    )}
  </div>
);

export default CompanyNameWithFlag;
